<template>
    <div class="w-full overflow-x-auto">
        <!--  -->
        <table class="min-w-full">
            <!--  -->
            <thead>
                <!--  -->
                <tr>
                    <!--  -->
                    <th v-if="name == 'cashflow'" class="px-3 w-10 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                        <label class="text-lg text-primary-600 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                            <input type="checkbox" @click="selectAllCheckbox($event)" class="form-checkbox checkallbboxShipp focus:outline-none focus:shadow-outline" />
                        </label>
                    </th>
                    <!--  -->

                    <!--  -->
                    <th v-for="(item, key) in headers" :key="key" class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                        {{ $t(item) }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                    </th>
                    <!--  -->
                </tr>
            </thead>
            <!--  -->

            <!--  -->
            <tbody class="bg-white">
                <!--  -->
                <tr v-for="(item, index) in content" :key="index">
                    <!--  -->
                    <td v-if="name == 'cashflow'" class="px-3 whitespace-no-wrap border-b border-gray-300">
                        <label class="text-lg text-primary-600 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                            <input type="checkbox" @click="getRowDetail(item, item._id)" :id="item._id" :status="item.validated" :class="'rowProduct-' + item._id" class="form-checkbox rowCheckboxCash focus:outline-none focus:shadow-outline" />
                        </label>
                    </td>
                    <!--  -->

                    <!--  -->
                    <td v-if="content[index]" v-for="(it, ind) in headers" :key="ind" class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div v-if="(it == 'AddedBy' || it == 'ValidatedBy' ) && name == 'cashflow'" class="flex">
                            <div class=" text-black font-normal flex justify-center items-center">
                                <p>{{ content[index][it] ? content[index][it]['fullName'] : '' }}</p>
                            </div>
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else-if="it == 'shippingCompany' && name == 'cashflow'" class="flex">
                            <div class="rounded text-black px-4 py-1 flex justify-center items-center">
                                <img v-if="content[index]['shippingCompany'] !== 'System' && getCourierClass(content[index]['shippingCompany']) !='unkonwn' " class="h-10" :src="getCourierClass(content[index]['shippingCompany'])" />
                                <p v-else class="text-black font-semibold text-sm">
                                    {{ content[index]['shippingCompany'] }}
                                </p>
                            </div>
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else-if="it == 'date' && name == 'cashflow'" class="flex">
                            <!--  -->
                            <a @click="content[index]['status'] !== 'Charge' ? setCurrenItem(content[index]) : null" class="rounded cursor-pointer gap-2 text-sm px-3 flex justify-center items-center">
                                <!--  -->
                                <p v-if="content[index]['status'] == 'Charge'">
                                    {{$moment(content[index]['dateCharge']).format('yyyy-MM-DD HH:mm')}}
                                </p>
                                <!--  -->

                                <!--  -->
                                <p v-if="content[index]['status'] == 'Pending'">
                                    {{$moment(content[index]['datePending']).format('yyyy-MM-DD HH:mm')}}
                                </p>
                                <!--  -->

                                <!--  -->
                                <p v-if="content[index]['status'] == 'Paid'">
                                    {{$moment(content[index]['datePaid']).format('yyyy-MM-DD HH:mm')}}
                                </p>
                                <!--  -->

                                <!--  -->
                                <p v-if="content[index]['status'] == 'Processed'">
                                    {{$moment(content[index]['dateProcessed']).format('yyyy-MM-DD HH:mm')}}
                                </p>
                                <!--  -->

                                <!--  -->
                                <span v-if="content[index]['status'] !== 'Charge'">
                                    <!--  -->
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                        <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z" clip-rule="evenodd" />
                                    </svg>
                                    <!--  -->
                                </span>
                                <!--  -->
                            </a>
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else-if="it == 'status' && name == 'cashflow' && content[index][it]" class="flex">
                            <div :class="`bg-${content[index]['color']}`" class="rounded text-white px-3 py-1 flex justify-center items-center">
                                <p class="font-semibold text-sm">{{ content[index][it] }}</p>
                            </div>
                        </div>
                        <!--  -->


                        <div v-else-if="it == 'validated' && name == 'cashflow'">
                            <!--  -->
                            <div v-if="content[index] && content[index][it] === 'Oui'">
                                <button class="rounded-full flex items-center text-black focus:outline-none">
                                    <i class="material-icons mr-2">check_circle</i><span>{{ $t('validated') }}</span>
                                </button>
                            </div>
                            <!--  -->

                            <!--  -->
                            <div v-else-if="getAccess(name, 'update')" class="flex">
                                <button @click="validateCharge(content[index])" class="border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none" style=" color: rgb(238, 43, 43); border-color: rgb(238, 43, 43);">
                                    {{ $t('validate') }}
                                </button>
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else class="text-sm leading-5 capitalize px-2 font-semibold rounded-full text-gray-900">
                            <span v-if="it == 'TotalAmount'">{{ (content[index][it]).toFixed(2) }} </span>
                            <span v-else>{{ content[index][it] }} </span>
                        </div>
                        <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div class="flex justify-end">
                            <!--  -->
                            <router-link v-if=" getAccess(name, 'update') && name == 'cashflow' && content[index]['validated'] != 'Oui'" :class="$colors.actionTable" class="rounded-full flex justify-center items-center w-8 h-8 mr-3 mt-1" :to="`${name}/edit/${content[index]['_id']}`">
                                <i class="material-icons mx-2">edit</i>
                            </router-link>
                            <!--  -->

                            <!--  -->
                            <button v-if="getAccess(name, 'delete')" :class="$colors.actionTable" @click="remove(content[index]['_id'])" class="rounded-full flex justify-center items-center focus:outline-none w-8 h-8 mr-3 mt-1">
                                <i class="material-icons mx-2">delete</i>
                            </button>
                            <!--  -->
                        </div>
                        <!--  -->
                    </td>
                    <!--  -->
                </tr>
                <!--  -->
            </tbody>
            <!--  -->
        </table>
        <!--  -->

        <!--  -->
        <vue-modal-2 v-if="currentItem" name="DateHistory" :headerOptions="{ title: `Dates History` }" @on-close="CloseModal('DateHistory')" :noFooter="true" modalSize="md">
            <!--  -->
            <div class="flex flex-col px-4 gap-3 justify-center items-center w-full rounded-lg py-3 mb-6">
                <!--  -->
                <div v-if="currentItem.dateProcessed" class="flex justify-start w-full items-center gap-3 px-4 py-3 rounded-md bg-gray-200 shadow">
                    <p class="text-md font-semibold ">Processed</p>
                    <p> {{$moment(currentItem['dateProcessed']).format('yyyy-MM-DD HH:mm', )}}</p>
                </div>
                <!--  -->

                <!--  -->
                <div v-if="currentItem.datePaid" class="flex justify-start w-full items-center gap-3 px-4 py-3 rounded-md bg-gray-200 shadow">
                    <p class="text-md font-semibold ">Paid</p>
                    <p> {{$moment(currentItem['datePaid']).format('yyyy-MM-DD HH:mm', )}}</p>
                </div>
                <!--  -->

                <!--  -->
                <div v-if="currentItem.datePending" class="flex justify-start w-full items-center gap-3 px-4 py-3 rounded-md bg-gray-200 shadow">
                    <p class="text-md font-semibold ">Pending</p>
                    <p> {{$moment(currentItem['datePending']).format('yyyy-MM-DD HH:mm', )}}</p>
                </div>
                <!--  -->
            </div>
            <!--  -->
        </vue-modal-2>
        <!--  -->

        <!--  -->
        <div v-if="content.length <= 0" class="bg-orange-100 py-8">
            <!--  -->
            <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                <!--  -->
                <p class="font-semibold flex text-black whitespace-no-wrap">
                    <i class="material-icons mx-3">error</i>
                    <span class="">{{ $t('no_rows_selected') }} </span>
                </p>
                <!--  -->
            </span>
            <!--  -->
        </div>
        <!--  -->
    </div>
</template>

<script>
import althiqua from '../../public/althiqua-logo.svg';
import cathedis from '../../public/cathedis-logo.png';
import ozon from '../../public/ozon-logo.png';
import ameex from '../../public/ameex-ma.png';
import speedship from '../../public/speedship-logo.png';

export default {
    props: {
        headers: { default: [] },
        content: { default: [] },
        name: { type: String, default: '' },
        country: { type: String, default: 'CI' },
        refresh: { type: Function },
        idWharhouse: { type: Object },
        currentUser: { type: Object },
    },
    data() {
        return {
            filters: [],
            status: ['active', 'inactive', 'blocked', 'deleted'],
            statusOrder: [],
            actions: [],

            options: this.$countries,
            paginate: {
                limit: 0,
                page: 1,
                total: 0,
                current_page: 0,
                lastpage: 0,
            },
            // currentUser: {
            //   role: {},
            // },
            newSeller: {},
            roles: [],
            categories: [],
            warehouses: [],
            countries: null,
            selectedCountries: [],
            tabId: [],
            currentItem: null
        };
    },
    async mounted() {
        //await this.getUser();

        if (this.currentUser) {
            if (this.currentUser.type == 'Admin' || this.currentUser.type == 'CEO')
                await this.getRoles();
            await this.getStatus();
            await this.getWarehouses();
            await this.getCategories();
            this.refreshChild();
        }
        this.countries = this.subscriber ? this.subscriber.user.country : null;
    },
    methods: {
        setCurrenItem(item) {
            this.currentItem = item
            console.log('currentItem---------', this.currentItem)
            this.open('DateHistory')
        },
        getCourierClass(courier) {
            if (courier) {
                switch (courier.toUpperCase()) {
                    case 'MAYLERZ':
                        return 'https://static.wixstatic.com/media/28da16_e1e4d20e61e544fd84c0af67c90063c0~mv2.png/v1/fill/w_130';
                    case 'CATHEDIS':
                        return cathedis;
                    case 'OZON EXPRESS':
                        return ozon;
                    case 'ARAMEX':
                        return 'https://storeno.b-cdn.net/edco/3-2023/1678458827905.png';
                    case 'AMEEX':
                        return ameex;
                    case 'ALTHIQUA':
                        return althiqua;
                    case 'SPEEDSHIP':
                        return speedship;
                    case 'DIGYLOG':
                        return 'https://storeno.b-cdn.net/edco/11-2022/1668194728662.png';
                    default:
                        return 'unkonwn';
                }
            }
            return 'unkonwn';
        },
        async CloseModal(id) {
            this.$vm2.close(id);
        },
        async open(name) {
            this.$vm2.open(name);
        },
        getRowDetail(item, id) {
            console.log('item-----', item);
            let itemInRow = this.tabId.filter((item) => item.id === id);
            let isItemInRow = itemInRow.length > 0;

            if (isItemInRow) {
                let pos = this.tabId
                    .map(function (e) {
                        return e.id;
                    })
                    .indexOf(id);
                this.tabId.splice(pos, 1);
            } else {
                this.tabId.push({ id: id, validated: item.status });
            }
            if (this.tabId.length === 0) {
                let columns = document.querySelectorAll('.checkallbboxShipp');
                columns.forEach((column) => {
                    column.checked = false;
                });
            }
        },
        selectAllCheckbox($event) {
            let columns = document.querySelectorAll('.rowCheckboxCash');
            this.tabId = [];
            if ($event.target.checked == true) {
                columns.forEach((column) => {
                    column.checked = true;
                    this.tabId.push({
                        id: column.id,
                        validated: column.getAttribute('status'),
                    });
                });
            } else {
                columns.forEach((column) => {
                    column.checked = false;
                });
                this.tabId = [];
            }
        },
        CheckActivite(user) {
            if (user.last_activity && user.type == 'Admin') {
                let nowSub = this.$moment(new Date())
                    .subtract(5, 'minutes')
                    .format('yyyy-MM-DD HH:mm:ss');
                let activite = '';
                activite = 'Offline ' + this.$moment(user.last_activity).fromNow();
                const activitedate = user.last_activity;

                if (new Date(activitedate) > new Date(nowSub)) activite = 'Online';

                return activite;
            }
        },
        async getWarehouses() {
            const filter = { limit: 10 };
            const res = await this.$server.search('warehouses', filter);
            if (res.content.results) {
                this.warehouses = res.content.results;
            } else this.warehouses = [];
        },
        activate: function (el) {
            this.subscriber.settings[el] = !this.subscriber.settings[el];
        },
        async closeModal() {
            this.$vm2.close('ModalChangeSetSettings');
            await this.refresh();
        },
        async setSelectedContry(contry) {
            if (contry) {
                this.selectedCountries = contry;
            }
        },
        async getUser() {
            const res = await this.$me;
            this.currentUser = res.content;
        },
        async getRoles() {
            const res = await this.$server.search('roles');
            if (res.content) this.roles = res.content.results;
            else this.roles = [];
        },
        async getCategories() {
            const res = await this.$server.search('categories');
            if (res.content) this.categories = res.content.results;
            else this.categories = [];
        },
        async remove(id) {
            this.$confirm('Are you sure ?').then(async (res) => {
                if (res) {
                    const data = await this.$server.delete(this.name, { _id: id });
                    //console.log("HIII");
                    if (data._id) {
                        alert(`${this.name} deleted !`, 'success');
                        await this.refreshChild();
                    }
                }
            });
        },
        async getStatus() {
            const res = await this.$server.search('status');
            if (res.content.results) this.statusOrder = res.content.results;
            else this.statusOrder = [];
        },
        async refreshChild() {
            await this.refresh();
        },
        async ChangeStatus(dataToEdit) {
            dataToEdit.updateIntable = true;
            const data = await this.$server.update('users', dataToEdit);
            if (data._id) {
                alert('User updated', 'success');
            }
        },

        async ChangeStatusOrder(dataToEdit) {
            const data = await this.$server.update('orders', dataToEdit);
            if (data._id) {
                alert('Order updated', 'success');
            }
        },
        async getUser() {
            const res = await this.$server.me('users');
            if (res.content) this.currentUser = res.content;
            else this.currentUser = [];
        },

        validateCharge(charge) {
            if (this.currentUser.type != 'CEO') {
                alert(
                    "You don't have the permission to validate this record",
                    'warning',
                );
            } else {
                this.$confirm('Are you sure ?').then(async (res) => {
                    charge.validated = 'Oui';
                    charge.AddedBy = charge.AddedBy._id;
                    charge.ValidatedBy = this.currentUser._id;
                    if (res) {
                        const data = await this.$server.update(this.name, charge);
                        //console.log("HIII");
                        if (data && data._id)
                            alert(this.$t('cashflow_validated'), 'success');
                        await this.refreshChild();
                    } else {
                        charge.status = 'Non';
                    }
                });
            }
        },

        validateMultipleCharge() {
            if (this.name == 'cashflow') {
                let columns = document.querySelectorAll('.rowCheckboxCash');

                const validated = this.tabId.filter((item) => item.validated == 'Oui');
                if (this.currentUser.type != 'CEO') {
                    alert(
                        "You don't have the permission to validate this record",
                        'warning',
                    );
                } else if (this.tabId.length == 0) {
                    alert('Please select the operations you want to validate', 'warning');
                } else if (validated && validated.length > 0) {
                    alert(
                        'Please select the operations that are not yet validated',
                        'warning',
                    );
                } else {
                    this.$confirm('Are you sure ?').then(async (res) => {
                        if (res) {
                            const data = await this.$server.updateMany(this.name, {
                                operations: this.tabId,
                                userValide: this.currentUser._id,
                            });
                            //console.log("HIII");
                            if (data && data._id)
                                alert(this.$t('cashflow_validated'), 'success');
                            columns.forEach((column) => {
                                column.checked = false;
                            });

                            await this.refreshChild();
                        } else {
                            columns.forEach((column) => {
                                column.checked = false;
                            });
                        }
                    });
                }
            }
        },

        getAccess(modelToCheck, accessToCheck) {
            const permissions = this.currentUser.role.permissions;

            for (let i in permissions) {
                let model = permissions[i]['model'];
                let access = permissions[i]['access'];

                if (model == modelToCheck) {
                    return access[accessToCheck];
                }
            }
        },
    },
};
</script>

<!--  ************  -->

<style scoped>
dialog:not([open]) {
    display: none;
}

.bg-redd {
    background-color: #f3bcbc !important;
}

div.online-indicator {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 5px;
    background-color: #0fcc45;
    border-radius: 50%;
    position: relative;
}

span.blink {
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    animation: blink 1s linear infinite;
}

h2.online-text {
    display: inline;
    font-family: 'Rubik', sans-serif;
    font-weight: 400;
    text-shadow: 0px 3px 6px rgb(150 150 150 / 20%);
    position: relative;
    cursor: pointer;
    vertical-align: top;
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
    overflow-y: hidden;
    font-size: 0.8125rem;
    line-height: 1.2308;
    -moz-osx-font-smoothing: grayscale;
    font-weight: normal;
    color: #64666a;
    word-wrap: break-word;
}

span.blink .online {
    background-color: #0fcc45;
    opacity: 0.7;
}

span.blink.offline {
    background-color: #e10b0b;
    opacity: 1;
}
</style>